module.exports = __webpack_public_path__ + "img/21.c26a83bd.png";